const getApiError = (error) => {

    if (!error) {
        return "خطای ناشناخته رخ داده است.";
    }

    // اینترنت یا سرور در دسترس نیست
    if (!error.response) {
        
        return error.message ||

        "ارتباط با سرور برقرار نشد.";
    }

    const { status, data } = error.response;

    // اگر Backend فقط رشته برگرداند
    if (typeof data === "string") {
        return data;
    }

    // اگر message داشته باشد
    if (data?.message) {
        return data.message;
    }

    // Validation Errors
    if (data?.errors) {

        const firstKey = Object.keys(data.errors)[0];

        if (firstKey && data.errors[firstKey]?.length) {
            return data.errors[firstKey][0];
        }

    }

    // بر اساس StatusCode

    switch (status) {

        case 400:
            return "اطلاعات ارسالی معتبر نیست.";

        case 401:
            return "برای ادامه ابتدا وارد حساب کاربری شوید.";

        case 403:
            return "شما اجازه انجام این عملیات را ندارید.";

        case 404:
            return "اطلاعات مورد نظر پیدا نشد.";

        case 409:
            return "این اطلاعات قبلاً ثبت شده است.";

        case 422:
            return "اطلاعات وارد شده قابل پردازش نیست.";

        case 500:
            return "خطایی در سرور رخ داده است.";

        default:
            return "خطایی رخ داده است.";

    }

};

export default getApiError;